import reducer from "./reducer";
export { default as NineBoxClassification } from "./components/index";
export { default as nineBoxClassificationReducerName } from "./constants";
export default reducer;
